import { useEffect, useContext } from 'react';
import { useGlobalState } from 'mmbclient/Common/CommonHooks';
import { GLOBAL_CONTEXT } from 'mmbclient/Common/CommonVariable'
import AuthRouting from 'mmbclient/Components/AuthRouting';
import { checkSession } from 'mmbclient/Common/CommonService';

const Main = () => {
    return (
        <GLOBAL_CONTEXT.Provider value={useGlobalState()}>
            <Start />
        </GLOBAL_CONTEXT.Provider>
    );
}

const Start = () => {

    const store = useContext(GLOBAL_CONTEXT);

    useEffect(() => {
        checkSession(store);
    }, []);

    return (
        <AuthRouting />
    );
}

export default Main
